import { render, staticRenderFns } from "./kundeadmin.vue?vue&type=template&id=0bd01246&scoped=true&"
import script from "./kundeadmin.vue?vue&type=script&lang=js&"
export * from "./kundeadmin.vue?vue&type=script&lang=js&"
import style0 from "./kundeadmin.vue?vue&type=style&index=0&id=0bd01246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd01246",
  null
  
)

export default component.exports